import createIcon from '../../createIcon';

/**
 * @component @name SmartToy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOS41VjcuNUMyMCA2LjQgMTkuMSA1LjUgMTggNS41SDE1QzE1IDMuODQgMTMuNjYgMi41IDEyIDIuNUMxMC4zNCAyLjUgOSAzLjg0IDkgNS41SDZDNC45IDUuNSA0IDYuNCA0IDcuNVY5LjVDMi4zNCA5LjUgMSAxMC44NCAxIDEyLjVDMSAxNC4xNiAyLjM0IDE1LjUgNCAxNS41VjE5LjVDNCAyMC42IDQuOSAyMS41IDYgMjEuNUgxOEMxOS4xIDIxLjUgMjAgMjAuNiAyMCAxOS41VjE1LjVDMjEuNjYgMTUuNSAyMyAxNC4xNiAyMyAxMi41QzIzIDEwLjg0IDIxLjY2IDkuNSAyMCA5LjVaTTcuNSAxMkM3LjUgMTEuMTcgOC4xNyAxMC41IDkgMTAuNUM5LjgzIDEwLjUgMTAuNSAxMS4xNyAxMC41IDEyQzEwLjUgMTIuODMgOS44MyAxMy41IDkgMTMuNUM4LjE3IDEzLjUgNy41IDEyLjgzIDcuNSAxMlpNMTYgMTcuNUg4VjE1LjVIMTZWMTcuNVpNMTUgMTMuNUMxNC4xNyAxMy41IDEzLjUgMTIuODMgMTMuNSAxMkMxMy41IDExLjE3IDE0LjE3IDEwLjUgMTUgMTAuNUMxNS44MyAxMC41IDE2LjUgMTEuMTcgMTYuNSAxMkMxNi41IDEyLjgzIDE1LjgzIDEzLjUgMTUgMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SmartToy = createIcon('SmartToy', [
  [
    'path',
    {
      d: 'M20 9.5V7.5C20 6.4 19.1 5.5 18 5.5H15C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5H6C4.9 5.5 4 6.4 4 7.5V9.5C2.34 9.5 1 10.84 1 12.5C1 14.16 2.34 15.5 4 15.5V19.5C4 20.6 4.9 21.5 6 21.5H18C19.1 21.5 20 20.6 20 19.5V15.5C21.66 15.5 23 14.16 23 12.5C23 10.84 21.66 9.5 20 9.5ZM7.5 12C7.5 11.17 8.17 10.5 9 10.5C9.83 10.5 10.5 11.17 10.5 12C10.5 12.83 9.83 13.5 9 13.5C8.17 13.5 7.5 12.83 7.5 12ZM16 17.5H8V15.5H16V17.5ZM15 13.5C14.17 13.5 13.5 12.83 13.5 12C13.5 11.17 14.17 10.5 15 10.5C15.83 10.5 16.5 11.17 16.5 12C16.5 12.83 15.83 13.5 15 13.5Z',
      key: 'ngw158',
    },
  ],
]);

export default SmartToy;
